/**
 * NakshatraSection - Registration for Nakshatra Chakra toggle and table
 * Demonstrates toggle with subdivisions (pada) in enhanced plugin system
 */

import { enhancedRegistry } from '../registry/EnhancedSectionRegistry';
import { JatakaResponse } from '../../../../../models/api';

// Register Nakshatra Chakra toggle (includes Pada automatically)
enhancedRegistry.register({
    id: 'nakshatra-chakra-toggle',
    parentSection: 'Nakshatra',
    label: 'Nakshatra Chakra',
    type: 'toggle',
    order: 1, // First item in Nakshatra details

    // Component will be rendered by PanchangaDetail using UniversalDivisionalToggle
    component: () => null, // Placeholder, actual rendering handled by registry

    // Props for UniversalDivisionalToggle
    componentProps: {
        toggleLabel: 'Nakshatra Chakra',
        colorScheme: 'purple',
        itemId: 'nakshatra-chakra',
        // UniversalDivisionalToggle will automatically show Pada toggle based on config
    },

    // Chakra integration
    chakra: {
        id: 'nakshatra-chakra',
        triggerOn: 'show',
        autoRegister: true
    },

    // Conditional rendering - only show if nakshatra data exists
    condition: (apiResponse: JatakaResponse) => {
        return !!(apiResponse.panchanga?.nakshatra || apiResponse.detailed_panchanga?.nakshatra_details);
    },

    // Event handlers (optional)
    events: {
        onMount: (apiResponse: JatakaResponse) => {
            // Placeholder for future event handling
        },

        onChakraToggle: (enabled: boolean) => {
            // Placeholder for future event handling
        }
    }
});

// Nakshatra Anga table is already registered in NakshatraAngaSection.tsx
// This demonstrates that multiple registrations can target the same parent section

// Export for module system
export default {};
